import { displayTime } from "./datepicker_util";
export function dateToString(date) {
  const year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  if (month < 10) {
    month = `0${month}`;
  }
  if (day < 10) {
    day = `0${day}`;
  }
  return `${year}-${month}-${day}`;
}
export function setEndOfDay(date) {
  date.setHours(23, 59, 59, 999);
  return date;
}
export function setStartOfDay(date) {
  date.setHours(0, 0, 0, 0);
  return date;
}
export function dateToInputFormat(date) {
  const formattedDate = dateToString(date);
  const formattedTime = displayTime(date);
  return `${formattedDate}T${formattedTime}`;
}
export function validDateFormat(date) {
  return /^\d{2}\/\d{2}\/\d{4}$/.test(date);
}
export function validTimeFormat(time) {
  return /^\d{2}:\d{2}$/.test(time);
}
